import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type ThemeMode } from '../state/Theme';
import { vars } from '../styles/theme.css';

const OPTIONS: Array<{
  value: ThemeMode;
  Icon: typeof Sun;
  label: string;
}> = [
  { value: 'light', Icon: Sun, label: 'Light' },
  { value: 'auto', Icon: Monitor, label: 'Auto' },
  { value: 'dark', Icon: Moon, label: 'Dark' },
];

export function ThemePicker() {
  const { mode, setMode } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center gap-0.5"
      style={{
        backgroundColor: vars.color.surface2,
        padding: 2,
        borderRadius: 8,
        border: `1px solid ${vars.color.border}`,
      }}
    >
      {OPTIONS.map(({ value, Icon, label }) => {
        const active = mode === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            onClick={() => setMode(value)}
            className="flex items-center justify-center transition-colors"
            style={{
              width: 30,
              height: 26,
              borderRadius: 6,
              backgroundColor: active ? vars.color.surface : 'transparent',
              color: active ? vars.color.ink : vars.color.inkMuted,
              boxShadow: active ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
            }}
          >
            <Icon size={14} strokeWidth={2} />
          </button>
        );
      })}
    </div>
  );
}
